export { default as ImageStyle } from '@ckeditor/ckeditor5-image/src/imagestyle'